import Group from '@/models/group'

export default class Data {
  static async import() {
    await Group.create('Ambat Family', [
      'Julia Ambat',
      'James Ambat',
      'Jeffrey Ambat',
      'Jamie Ambat',
      'Maribel Ambat',
    ], false)

    await Group.create('Mum & Dad', [
      'Kim-Anh Nguyen',
      'Simon Skiffington',
    ], false)

    await Group.create('Xuan-Anh & Joseph', [
      'Xuan-Anh Nguyen',
      'Joseph Dowsett',
    ], false)

    await Group.create('Vinh & Liv', [
      'Vinh Nguyen',
      'Olivia Date',
    ], false)

    await Group.create('Bác Chi & Bác Huyên', [
      'Chi Dang',
      'Huyên Dang',
    ], false)

    await Group.create('Que & Law', [
      'Que Dang',
      'Lawrence Chan',
    ], false)

    await Group.create('Jono', [
      'Jonathan Dang',
    ], false)

    await Group.create('The Munro\'s', [
      'Dì Kìm Em',
      'Grant Munro',
    ], false)

    await Group.create('Minh', [
      'Michael Munro',
    ], true)

    await Group.create('Sean', [
      'Sean Munro',
    ], false)

    await Group.create('Nick & Zora', [
      'Nick Munro',
      'Zora Niemann',
    ], false)

    await Group.create('Ông & Bà', [
      'Ông',
      'Bà',
    ], false)

    await Group.create('Paul & Lisa', [
      'Paul Vu',
      'Lisa Pham',
    ], false)

    await Group.create('Vu Family', [
      'Joe Vu',
      'Lisa Um',
      'Evelyn Vu',
    ], false)

    await Group.create('Vu Family', [
      'Ông Cậu',
      'Bà Mỏ',
      'Khuyên',
    ], false)

    await Group.create('Cô Phưỏng', [
      'Cô Phưỏng',
    ], false)

    // TODO: Need to fix additionals to be more than just one.
    // await Group.create('Nguyen Family', [
    //   'Chú Mỹ',
    //   'Thím Yến',
    //   'Huy Nguyen',
    //   'Anna Nguyen',
    // ], false)

    // await Group.create('Nguyen Family', [
    //   'Chú Quốc',
    //   'Thím Linh',
    //   'Khuong Nguyen',
    //   'Khang Nguyen',
    // ], false)

    await Group.create('Huong', [
      'Huong Nguyen',
    ], false)

    await Group.create('Le Family', [
      'Jason Le',
      'Annie Lam',
      'Arden Le',
      'Van Thang Le',
      'Thi Ngoc Yen Le',
    ], false)

    await Group.create('Aaron & Jamie', [
      'Aaron Jackson',
      'Jamie Lee',
    ], false)

    await Group.create('Erik & Peggy', [
      'Erik Zhong',
      'Peggy Ling',
    ], false)

    await Group.create('Marty & Ayesha', [
      'Martin Groen',
      'Ayesha Groen',
    ], false)

    await Group.create('Geoff', [
      'Geoff Cowan',
    ], false)

    await Group.create('Wilhelm & Jacinta', [
      'Wilhelm Eek',
      'Jacinta Hudson',
    ], false)

    await Group.create('Aaron & Carmen', [
      'Aaron Ramshaw',
      'Carmen Gawthorpe',
    ], false)

    await Group.create('Simon', [
      'Simon Robilliard',
    ], true)

    await Group.create('Lav', [
      'Lavender Chan',
    ], false)

    await Group.create('Leo & Louise', [
      'Leo Yip',
      'Louise Austin',
    ], false)

    await Group.create('Keto', [
      'John Keto',
    ], true)

    await Group.create('Anshul', [
      'Anshul Jain',
    ], true)

    await Group.create('Morales Family', [
      'Cristina Morales',
      'Rey Morales',
      'Sydney Morales',
      'Tiffany Morales',
    ], false)

    await Group.create('Macalalad Family', [
      'Marlo Macalalad',
      'Dolan Macalalad',
      'Lexus Macalalad',
      'Dana Dela Cruz',
      'Lynuz Macalalad',
    ], false)

    await Group.create('Yves', [
      'Yves Sy',
    ], true)

    await Group.create('Johnny', [
      'Johnny Estilles',
    ], false)

    await Group.create('Bác Yến & Bác Trang', [
      'Bác Yến',
      'Bác Trang',
    ], false)
  }

  async check() {
    // TODO: Check for code collisions.
  }
}